<template>
  <callback-status variant="confirmation" />
</template>

<script>
import CallbackStatus from './CallbackStatus.vue'

export default {
  components: { CallbackStatus },
}
</script>
